import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
})

// Database types
export type Store = {
  id: string
  name: string
  slug: string
  domain: string | null
  subdomain: string | null
  logo_url: string | null
  owner_id: string
  plan: 'free' | 'starter' | 'pro' | 'enterprise'
  status: 'active' | 'suspended' | 'cancelled'
  settings: Record<string, any>
  created_at: string
  updated_at: string
}

export type StoreUser = {
  id: string
  store_id: string
  user_id: string
  role: 'owner' | 'admin' | 'manager' | 'staff'
  permissions: Record<string, any>
  invited_by: string | null
  invited_at: string
  accepted_at: string | null
  created_at: string
}

export type Product = {
  id: string
  store_id: string
  category_id: string | null
  name: string
  slug: string
  sku: string | null
  brand: string | null
  description: string | null
  price: number
  compare_at_price: number | null
  cost_price: number | null
  stock: number
  low_stock_threshold: number
  images: string[]
  tags: string[]
  is_active: boolean
  is_featured: boolean
  seo_title: string | null
  seo_description: string | null
  metadata: Record<string, any>
  created_at: string
  updated_at: string
}

export type Category = {
  id: string
  store_id: string
  name: string
  slug: string
  parent_id: string | null
  image_url: string | null
  description: string | null
  sort_order: number
  is_active: boolean
  seo_title: string | null
  seo_description: string | null
  created_at: string
  updated_at: string
}

export type Order = {
  id: string
  store_id: string
  customer_id: string | null
  order_number: string
  status: 'pending' | 'processing' | 'shipped' | 'delivered' | 'cancelled' | 'refunded'
  payment_status: 'pending' | 'paid' | 'failed' | 'refunded' | 'partially_refunded'
  subtotal: number
  discount: number
  shipping: number
  tax: number
  total: number
  currency: string
  shipping_address: Record<string, any> | null
  billing_address: Record<string, any> | null
  customer_note: string | null
  admin_note: string | null
  tracking_number: string | null
  tracking_url: string | null
  fulfilled_at: string | null
  cancelled_at: string | null
  created_at: string
  updated_at: string
}

export type Customer = {
  id: string
  store_id: string
  email: string
  first_name: string | null
  last_name: string | null
  phone: string | null
  avatar_url: string | null
  total_spent: number
  total_orders: number
  tags: string[]
  notes: string | null
  accepts_marketing: boolean
  created_at: string
  updated_at: string
}
